const debug = process.env.REACT_APP_DEBUG && false;
export const valueSetters = {
    enum: (value, row) => {
        debug && console.log(`Detail Card enum value setting ${value.k} on kv got`, value);
        return { ...row, kv: value };
    },
    string: (value, row) => {
        debug && console.log(`Detail Card string value setting  ${value.k} on kv got`, value);
        return { ...row, kv: value };
    },
};
